import React from 'react';
import {View} from 'react-native';
import {isNull} from 'lodash';
import {isEmpty} from 'lodash/fp';

import Delta from '/component/base/Delta';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {DownlineProfile} from '/constant/TestIDs';
import {LABEL_COMING_SOON} from '/enum/label.enum';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './OrderMetrics.style';

interface OrderMetricsProps {
  tt: (key: string, fallback: string) => string;
  onShowInfoPopover: () => void;
  currentFrontlineVolume: string | number;
  lastMonthFrontlineVolume: number | null;
  deltaFrontlineVolume: number;
  currentGen0Volume: string | number;
  lastMonthGen0Volume: number | null;
  deltaGen0Volume: number;
  sameDayLastMonth: Record<string, any>;
}

export const OrderMetrics = ({
  tt,
  currentFrontlineVolume = 0,
  lastMonthFrontlineVolume = 0,
  deltaFrontlineVolume = 0,
  currentGen0Volume = 0,
  lastMonthGen0Volume = 0,
  deltaGen0Volume = 0,
  sameDayLastMonth = {},
}: OrderMetricsProps) => {
  return (
    <ProfileSection
      analyticsTitle="Order Metrics"
      style={{base: styles.base}}
      title={tt('heading', 'Order Metrics')}>
      <View style={styles.row}>
        <ListItem
          label={
            <Text allowFontScaling maxFontSizeMultiplier={2}>
              {tt('volume.currentFrontline', 'Current Frontline Volume')}
            </Text>
          }
          suffix={
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              testID={DownlineProfile.currentFrontlineVolume}
              variant="button"
              truncateValue={currentFrontlineVolume !== LABEL_COMING_SOON}>
              {currentFrontlineVolume}
            </Text>
          }
          style={{base: styles.listItem}}
          readonly={true}
        />
        {!isEmpty(sameDayLastMonth) && !isNull(lastMonthFrontlineVolume) && (
          <ListItem
            label={
              <Text allowFontScaling maxFontSizeMultiplier={2}>
                {tt('volume.lastMonthFrontline', 'Same Day Last Month')}
              </Text>
            }
            suffix={
              <View style={styles.listItemSuffix}>
                {deltaFrontlineVolume !== 0 &&
                  !isEmpty(deltaFrontlineVolume) && (
                    <Delta
                      style={{base: styles.listItemDelta}}
                      value={deltaFrontlineVolume}
                    />
                  )}
                <Text
                  allowFontScaling
                  maxFontSizeMultiplier={2}
                  style={styles.listItemValue}
                  variant="button"
                  truncateValue={
                    lastMonthFrontlineVolume !== LABEL_COMING_SOON
                  }>
                  {lastMonthFrontlineVolume}
                </Text>
              </View>
            }
            style={{base: styles.listItem}}
            readonly={true}
          />
        )}
      </View>
      <View style={[styles.row, styles.rowWithBorder]}>
        <ListItem
          label={
            <Text allowFontScaling maxFontSizeMultiplier={2}>
              {tt('volume.currentGen0', 'Current Generation 0 Volume')}
            </Text>
          }
          suffix={
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              testID={DownlineProfile.currentGen0Volume}
              variant="button"
              truncateValue={currentGen0Volume !== LABEL_COMING_SOON}>
              {currentGen0Volume}
            </Text>
          }
          style={{base: styles.listItem}}
          readonly={true}
        />
        {!isEmpty(sameDayLastMonth) && !isNull(lastMonthGen0Volume) && (
          <ListItem
            label={
              <Text allowFontScaling maxFontSizeMultiplier={2}>
                {tt('volume.lastMonthGen0', 'Same Day Last Month')}
              </Text>
            }
            suffix={
              <View style={styles.listItemSuffix}>
                {deltaGen0Volume !== 0 && !isEmpty(deltaGen0Volume) && (
                  <Delta
                    style={{base: styles.listItemDelta}}
                    value={deltaGen0Volume}
                  />
                )}
                <Text
                  allowFontScaling
                  maxFontSizeMultiplier={2}
                  style={styles.listItemValue}
                  variant="button"
                  truncateValue={lastMonthGen0Volume !== LABEL_COMING_SOON}>
                  {lastMonthGen0Volume}
                </Text>
              </View>
            }
            style={{base: styles.listItem}}
            readonly={true}
          />
        )}
      </View>
    </ProfileSection>
  );
};

export default withTranslation('screen.coachPerformance.section.orderMetrics')(
  OrderMetrics,
);
